// Mobile Menu Handler
// - Toggle-Funktionalität für das Hamburger-Menü
// - Backdrop-Handling zum Schließen
// - Smooth Scroll zu Ankern mit Topbar-Offset

function smoothScrollToTarget(href: string): void {
	// Anchor href auslesen
	if (!href.startsWith('#')) return;
	
	const targetId = href.substring(1);
	const target = document.getElementById(targetId);
	if (!target) return;

	// Topbar-Höhe ermitteln
	const topbar = document.querySelector('.fuelpipe-topbar') as HTMLElement | null;
	const topbarHeight = topbar ? topbar.offsetHeight : 0;

	// Scroll-Position berechnen
	const targetPosition = target.getBoundingClientRect().top + window.scrollY - topbarHeight - 16;

	// Smooth Scroll ausführen (bei "Bewegung reduzieren" direkt springen)
	window.scrollTo({
		top: targetPosition,
		behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
	});
}

export function initMobileMenu(): void {
    const currentPage = window.location.pathname.split('/').pop();
    const practiceLabel = document.querySelector('[data-practice-label]');
    const currentPractice = document.querySelector<HTMLAnchorElement>(
        `.practice-switcher .dropdown a[href="${currentPage === 'roelsdorf.html' ? 'roelsdorf.html' : 'dueren.html'}"]`
    );
    if (practiceLabel && currentPractice && (currentPage === 'dueren.html' || currentPage === 'roelsdorf.html')) {
        practiceLabel.textContent = currentPractice.textContent;
        currentPractice.classList.add('active-practice');
        currentPractice.setAttribute('aria-current', 'page');
    }
    document.querySelector('.practice-switcher .active-practice:not([aria-current])')?.setAttribute('aria-current', 'true');
	const toggle = document.querySelector('.menu-toggle') as HTMLElement | null;
	const backdrop = document.querySelector('.menu-backdrop') as HTMLElement | null;
	const navLinks = document.querySelectorAll('.fuelpipe-topbar nav a');

	if (!toggle || !backdrop) return;

	const toggleMenu = () => {
		const isOpen = document.body.classList.toggle('nav-open');
		toggle.classList.toggle('active');
		toggle.setAttribute('aria-expanded', String(isOpen));
		toggle.setAttribute('aria-label', isOpen ? 'Menü schließen' : 'Menü öffnen');
	};

	// Escape schließt das mobile Menü und gibt den Fokus an den Menü-Button zurück
	document.addEventListener('keydown', (e: KeyboardEvent) => {
		if (e.key === 'Escape' && document.body.classList.contains('nav-open')) {
			toggleMenu();
			toggle.focus();
		}
	});

	// Dropdown click handling
	const dropdownItems = document.querySelectorAll<HTMLElement>('li.has-dropdown');
	dropdownItems.forEach(item => {
		const trigger = item.querySelector(':scope > a, :scope > button') as HTMLElement | null;
		if (!trigger) return;

		// Aufklapp-Navigation (Disclosure), kein ARIA-Menü: daher nur aria-expanded, kein aria-haspopup
		trigger.setAttribute('aria-expanded', 'false');

		const toggleDropdown = (open?: boolean) => {
			const isOpen = open !== undefined ? open : !item.classList.contains('dropdown-open');
			item.classList.toggle('dropdown-open', isOpen);
			trigger.setAttribute('aria-expanded', String(isOpen));
		};

		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			toggleDropdown();
			// Close other open dropdowns
			dropdownItems.forEach(other => {
				if (other !== item) {
					other.classList.remove('dropdown-open');
					const otherTrigger = other.querySelector(':scope > a, :scope > button') as HTMLElement | null;
					if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
				}
			});
		});

		// Escape-Taste schließt das Dropdown
		item.addEventListener('keydown', (e: KeyboardEvent) => {
			if (e.key === 'Escape') { toggleDropdown(false); trigger.focus(); }
		});
	});

	// Close dropdown on outside click
	document.addEventListener('click', () => {
		dropdownItems.forEach(item => {
			item.classList.remove('dropdown-open');
			const trigger = item.querySelector(':scope > a, :scope > button') as HTMLElement | null;
			if (trigger) trigger.setAttribute('aria-expanded', 'false');
		});
	});

	toggle.addEventListener('click', (e) => {
		e.stopPropagation();
		toggleMenu();
	});
	
	backdrop.addEventListener('click', toggleMenu);

	navLinks.forEach(link => {
		link.addEventListener('click', (e) => {
			if (link.matches('li.has-dropdown > a')) return;
			const href = link.getAttribute('href');
			
			// Wenn es ein Anker ist, smooth scroll triggern
			if (href?.startsWith('#')) {
				e.preventDefault();
				smoothScrollToTarget(href);
			}
			
			// Menü schließen wenn offen
			if (document.body.classList.contains('nav-open')) {
				toggleMenu();
			}
		});
	});
}
